import React from "react";
import {
  Edit,
  SimpleForm,
  ImageInput,
  TextInput,
  Toolbar,
  FileInput,
  ListButton,
  SaveButton,
  ImageField,
  useRecordContext
} from "react-admin";



import { LabelTypeSelectInput, LabelIdSelectInput, LabelTaskSelectInput } from "../../UI/Input/SelectInput";
import { onAddonandVideoTaskLabelEdit } from "../../Service/Validation/AddonandVideoTaskLabelValidation";
import Grid from "@material-ui/core/Grid";
import { RichTextInput } from 'ra-input-rich-text';

const SanitizedGrid = ({ basePath, ...props }) => {
  return <Grid {...props} />;
};

const PageTitle = ({ record }) => {
  return <span>Labels: {record ? record.name : ""}</span>;
};
const FormToolbar = (props) => (
  <Toolbar {...props}>
    <SaveButton label="Save" redirect="list" submitOnEnter={true} />
    {!props.saving && <ListButton label="Cancel" />}
  </Toolbar>
);
const SliderImagesField = ({ source, onItemDelete}) => {
    const record = useRecordContext();
    //const classes = CustomerOfferImageStyles();    
    if (record.image_url === undefined) { return <p>No Image</p> }
    return (<div >
         <img style={{maxWidth:'300px'}} src={record.image_url.url} alt="" />
    </div>)
}

const MerchantIntentTesterLablesEdit = (props) => {
  return (
    <Edit title={<PageTitle />} {...props} undoable={false}>
      <SimpleForm warnWhenUnsavedChanges toolbar={<FormToolbar />} defaultValues={{ action: "full" }} redirect="list">
        <SanitizedGrid container spacing={3} fullWidth>
          <Grid item sm={12} md={12} lg={12}>
            
            <ImageInput className="commondropzone" source="image" label="Upload Image" accept="image/*">
                            <ImageField source="src" title="title" />
                    </ImageInput>  
             <SliderImagesField source="sitecarouselslide" label="Existing Image" addLabel={true}  />
          </Grid>
          <Grid item sm={12} md={12} lg={12}>
            <TextInput label="Title" source="title" fullWidth />
          </Grid>
          <hr></hr>
          <Grid item sm={12} md={12} lg={12}>
            <TextInput label="Product URL" source="product_url" fullWidth />
          </Grid>
          <Grid item sm={12} md={6} lg={6}>
            <TextInput label="Label 1" source="radio_label1" fullWidth />
          </Grid>
          <Grid item sm={12} md={6} lg={6}>
            <TextInput label="Label 2" source="radio_label2" fullWidth />
          </Grid>
          <hr></hr>
          <Grid item sm={12} md={12} lg={12}>
            <TextInput label="Text Input Title" source="text_field_title" fullWidth />
          </Grid>
          <Grid item sm={12} md={12} lg={12}>
            <TextInput label="Text Input" source="text_field_value" fullWidth />
          </Grid>
        </SanitizedGrid>
      </SimpleForm>
    </Edit>
  );
};

export default MerchantIntentTesterLablesEdit;
